<template lang="pug">
  li.list-group-item
    div(v-if="loading && showNodata && (this.groupData === null)")
      loading
    div(v-else)
      template(v-if="showRoot")
        .bcard-group-tree-item
          span.bcard-group-tree-angle-icon(v-if="hasChildren", @click.prevent="onClickFolder()", :title="[open ? '閉じる' : '開く']")
            i.fa(:class="open ? 'fa-angle-down' : 'fa-angle-right'")
          div(v-else).bcard-group-tree-no-angle-icon

          .bcard-group-tree-select-area(:class="[group.selected ? 'selected' : '']")
            a(href="#", @click.prevent="beforeOnClickName()", :title="group.name")
              i.fa(:class="group.selected ? 'fa-folder-o' : 'fa-folder'")
              span {{ group.name }}

          ul(v-if="loading").bcard-group-recursive
            li.list-group-item
              .bcard-group-tree-loading
                loading(:height="1", :faSize="''")

          ul.bcard-group-recursive(v-else-if="hasChildren" v-show="open")
            group-tree-item(v-for="group in children", :key="group.id", :onClickName="onClickName", :groupData="group", :selectedIds="selectedIds")

      template(v-else)
        ul
          group-tree-item(v-for="group in children", :key="group.id", :onClickName="onClickName", :groupData="group", :selectedIds="selectedIds")
          p.text-center(v-if="children.length === 0 && showNodata") 組織情報はありません。

</template>

<script>
import Loading from '@/components/molecules/Loading'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const GroupRepository = RepositoryFactory.get('group')

export default {
  name: 'GroupTreeItem',
  components: { Loading },
  props: {
    // 親コンポーネントの処理
    onClickName: {type: Function, required: true},
    // 再帰コンポーネントの組織情報
    groupData: {type: Object, required: false, default: null},
    // 選択中の組織ID
    selectedIds: {type: Array, required: false, default: null},
    // 選択上限数（1以外を設定すると複数選択処理）
    maxSelect: {type: Number, required: false, default: 1},
    // ルート(親組織)表示フラグ
    showRoot: {type: Boolean, required: false, default: true},
    // ツリー更新フラグ
    refresh: {type: Boolean, required: false, default: false},
    // nodata表示フラグ
    showNodata: {type: Boolean, required: false, default: false}
  },
  data: function () {
    return {
      // 親に渡すデータ
      group: {
        id: null,
        name: '',
        selected: false
      },
      // 子組織存在フラグ
      hasChildren: false,
      // 子組織データ
      children: [],
      // フォルダ開閉フラグ
      open: false,
      // 子組織取得済みフラグ
      append: false,
      // 子組織取得中フラグ
      loading: false
    }
  },
  watch: {
    // 選択中組織が変更されたらフラグを更新する
    selectedIds: function () {
      this.updateSelected()
    },
    // 組織ツリー更新
    refresh: function () {
      if (this.group.id === null && this.refresh) {
        this.append = false
        this.children = null
        // ルート以外が選択されている場合
        if (this.selectedIds && this.selectedIds[0]) {
          // 組織情報を一括取得
          this.getDefaultData()
        }
        else {
          this.getChildren()
        }
        this.$emit('complete-refreshing')
      }
    }
  },
  created: function () {
    // 先頭コンポーネント
    if (this.groupData === null) {
      this.group.id = null
      this.group.name = 'ルート'
      this.hasChildren = true
      this.open = true
      // 単一選択かつルート以外が選択されている場合
      if ((this.maxSelect === 1) && this.selectedIds && this.selectedIds[0]) {
        // 組織情報を一括取得
        this.getDefaultData()
      }
      else {
        this.getChildren()
      }
    }
    // 再帰コンポーネント
    else {
      this.group.id = this.groupData.id
      this.group.name = this.groupData.name
      this.hasChildren = this.groupData.hasChildren
      // 既に子組織が取得済みなら保存
      if (this.groupData.children && this.groupData.children[0]) {
        this.children = this.groupData.children
        this.open = true
        this.append = true
      }
    }
    // 初期選択組織ならフラグを更新
    this.updateSelected()
  },
  methods: {
    // フォルダアイコンクリック時
    onClickFolder: function () {
      // フォルダ開閉
      this.open = !this.open
      // 子組織を取得
      this.getChildren()
    },
    // 組織名クリック時
    beforeOnClickName: function () {
      // 子組織を取得し直す
      this.append = false
      this.getChildren()
      // 親のメソッドを呼び出す
      this.onClickName(this.group)
    },
    // 子組織を取得
    getChildren: function () {
      // 子組織が存在し、かつ未取得の場合は取得
      if (this.hasChildren && !this.append) {
        const vm = this
        // フォルダが開いているときのみローディングを表示する
        if (this.open) {
          this.loading = true
        }
        // 親組織IDがあればパラメータに含める
        const param = this.group.id ? {parent_id: this.group.id} : {}

        GroupRepository.tree(param)
          .then(function (response) {
            vm.children = vm.getApiData(response).data
            // 子組織取得済みフラグを更新
            vm.append = true
          })
          .catch(function (error) {
            vm.setErrorMessage(error)
          })
          .finally(function () {
            vm.loading = false
            if (vm.groupData === null) {
              vm.$emit('complete-initializing')
            }
          })
      }
    },
    // 単一選択かつルート以外が選択されている場合
    getDefaultData: function () {
      const vm = this
      this.loading = true
      // 組織情報を一括取得
      GroupRepository.tree({id: this.selectedIds[0]})
        .then(function (response) {
          vm.children = vm.getApiData(response).data
        })
        .catch(function (error) {
          vm.setErrorMessage(error)
        })
        .finally(function () {
          vm.loading = false
          if (vm.groupData === null) {
            vm.$emit('complete-initializing')
          }
        })
    },
    // 選択中フラグを更新する
    updateSelected: function () {
      if (this.selectedIds !== null) {
        // 自分が選択されている場合
        if (this.isIncludes(this.selectedIds, this.group.id)) {
          this.group.selected = true
          return
        }
      }
      this.group.selected = false
    }
  }
}
</script>

<style lang="scss" scoped>
  ul {
    position: relative;
    padding: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/organisms/GroupTreeItem.vue